import { EVENT_FIRED } from "store/constants";
import { IAnalyticsTracker } from "store/reducers/analyticsTracker";

import { createAction } from "@reduxjs/toolkit";

export interface IEventFiredPayload {
  event: string;
  experienceLocation?: "ONBOARDING" | "DASHBOARD";
  attribute?: { [key: string]: unknown };
}

/* ------------    ACTIONS     ------------------ */

export const eventFired = createAction<IEventFiredPayload>(EVENT_FIRED);

export const setUTMCodes = createAction<IAnalyticsTracker["utm"]>("SET_UTM_CODES");
